import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { useDispatch } from 'react-redux';
import Loginscreen from './Screens/Loginscreen';
import withAuth from './Hocs/withAuth';
import FranchiseeProfile from './Screens/FranchiseeProfile';
import MyAppointment from './Screens/MyAppointment';
import store, { persistor } from './redux/store';
import './App.css';
import { MenuProvider } from 'react-native-popup-menu';
import { PersistGate } from 'redux-persist/integration/react';
import "react-datepicker/dist/react-datepicker.css";
import EditAppointment from './Screens/EditAppointment';
import GeneralAppointmentscreen from './Screens/GeneralAppointmentscreen';
import AppointmentSettingScreen from './Screens/AppointmentSettingScreen';
import Sessionattandencescreen from './Screens/Sessionattandencescreen';
import Sessionreportscreen from './Screens/Sessionreportscreen';
import Nextsessionscreen from './Screens/Nextsessionscreen';
import UpcomingAppointmentScreen from './Screens/UpcomingAppointmentScreen';
import ReportListingPage from './Screens/ReportListingPage';
import SessionDetailsScreen from './Screens/SessionDetailsScreen';
import StudentFillDetailsScreen from './Screens/StudentFillDetailsScreen';
import Studentdatetimescreen from './Screens/Studentdateandtimescreen';
import Studentsetupscreen from './Screens/Studentsetupscreen';
import SelectAppointmentTypeScreen from './Screens/SelectAppointmentTypeScreen';
import SchoolFillDetailsScreen from './Screens/SchoolFillDetailsScreen';
import SchooldatetimeScreen from './Screens/SchooldateandtimeScreen';
import Schoolappointmentsetupscreen from './Screens/Schoolappointmentsetupscreen';
import Sessiontimedurationscreen from './Screens/Sessiontimedurationscreen';
import { NotFound } from './Screens/PageNotFound';
import Lottie from 'lottie-react';
import ForgotPasswordScreen from './Screens/ForgetPasswordScreen';
import { logoutUser } from './redux/actions/authActions';
import {TimePicker} from 'react-ios-time-picker';


// Component to handle auto-logout and navigation
function AppContent() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

    // Authenticated routes
  const AuthenticatedFranchiseeProfile = withAuth(FranchiseeProfile);
  const AuthenticatedMyAppointment = withAuth(MyAppointment);
  const AuthenticatedEditAppointment = withAuth(EditAppointment);
  const AuthenticatedGeneralAppointmentscreen = withAuth(GeneralAppointmentscreen);
  const AuthenticatedAppointmentSettingScreen = withAuth(AppointmentSettingScreen);
  const AuthenticatedSessionattandencescreen = withAuth(Sessionattandencescreen);
  const AuthenticatedSessionreportscreen = withAuth(Sessionreportscreen);
  const AuthenticatedNextsessionscreen = withAuth(Nextsessionscreen);
  const AuthenticatedUpcomingAppointmentScreen = withAuth(UpcomingAppointmentScreen);
  const AuthenticatedReportListingPage = withAuth(ReportListingPage);
  const AuthenticatedSessionDetailsScreen = withAuth(SessionDetailsScreen);
  const AuthenticatedStudentFillDetailsScreen = withAuth(StudentFillDetailsScreen);
  const AuthenticatedStudentdatetimescreen = withAuth(Studentdatetimescreen);
  const AuthenticatedStudentsetupscreen = withAuth(Studentsetupscreen);
  const AuthenticatedSelectAppointmentTypeScreen = withAuth(SelectAppointmentTypeScreen);
  const AuthenticatedSchoolFillDetailsScreen = withAuth(SchoolFillDetailsScreen);
  const AuthenticatedSchooldatetimeScreen = withAuth(SchooldatetimeScreen);
  const AuthenticatedSchoolappointmentsetupscreen = withAuth(Schoolappointmentsetupscreen);
  const AuthenticatedSessiontimedurationscreen = withAuth(Sessiontimedurationscreen);

  // Auto-logout after 1 hour
  useEffect(() => {
    const logoutTimer = setTimeout(() => {
      dispatch(logoutUser());
      navigate("/login");
    },60 * 60 * 1000);

    return () => clearTimeout(logoutTimer);
  }, [dispatch, navigate]);

  return (
    <Routes>
      <Route path="/" element={<Loginscreen />} />
      <Route path="/login" element={<Loginscreen />} />
      <Route path="/ForgetPassword" element={<ForgotPasswordScreen />} />
      <Route path="/FranchiseeProfile" element={<AuthenticatedFranchiseeProfile />} />
      <Route path="/MyAppointment" element={<AuthenticatedMyAppointment />} />
      <Route path="/editAppointment" element={<AuthenticatedEditAppointment />} />
      <Route path="/editgeneral" element={<AuthenticatedGeneralAppointmentscreen />} />
      <Route path="/appointmentsettings" element={<AuthenticatedAppointmentSettingScreen />} />
      <Route path="/appointmentdate-time" element={<AuthenticatedAppointmentSettingScreen />} />
      <Route path="/session-attandence" element={<AuthenticatedSessionattandencescreen />} />
      <Route path="/session-report" element={<AuthenticatedSessionreportscreen />} />
      <Route path="/next-session" element={<AuthenticatedNextsessionscreen />} />
      <Route path="/upcomingappointments" element={<AuthenticatedUpcomingAppointmentScreen />} />
      <Route path="/reportlisting" element={<AuthenticatedReportListingPage />} />
      <Route path="/sessiondetails" element={<AuthenticatedSessionDetailsScreen />} />
      <Route path="/filldetails" element={<AuthenticatedStudentFillDetailsScreen />} />
      <Route path="/student-date-time" element={<AuthenticatedStudentdatetimescreen />} />
      <Route path="/student-setup" element={<AuthenticatedStudentsetupscreen />} />
      <Route path="/SelectAppointmentType" element={<AuthenticatedSelectAppointmentTypeScreen />} />
      <Route path="/schoolfilldetails" element={<AuthenticatedSchoolFillDetailsScreen />} />
      <Route path="/schooldatetime" element={<AuthenticatedSchooldatetimeScreen />} />
      <Route path="/school-setup" element={<AuthenticatedSchoolappointmentsetupscreen />} />
      <Route path="/session-date-time" element={<AuthenticatedSessiontimedurationscreen />} />
      <Route
        path="*"
        element={
          <NotFound
            lottieElement={<Lottie animationData={require("../src/assets/404_page.json")} style={{ width: 300, height: 300 }} />}
          />
        }
      />
    </Routes>
  );
}

function App() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  // Handle online/offline status
  useEffect(() => {
    const updateOnlineStatus = () => setIsOnline(navigator.onLine);

    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);



  return (
    <>
      {/* Internet Connectivity Banner */}
      {!isOnline && (
        <div className="internet-warning">
          No Internet Connection. Please check your network.
        </div>
      )}

      <MenuProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Router>
              <AppContent />
            </Router>
          </PersistGate>
        </Provider>
      </MenuProvider>
    </>
  );
}

export default App;